import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const ServiceCardSkeleton = () => {
  return (
    <Card className="overflow-hidden flex flex-col h-full group">
      {/* Image skeleton */}
      <div className="relative aspect-square overflow-hidden">
        <Skeleton className="h-full w-full" />
      </div>

      {/* Content skeleton */}
      <div className="p-4 flex flex-col flex-grow">
        <Skeleton className="h-5 w-3/4 mb-2" />
        <Skeleton className="h-4 w-1/2 mb-4" />
        <Skeleton className="h-4 w-full mb-2" />
        <Skeleton className="h-4 w-5/6 mb-4" />
        
        <div className="mt-auto pt-2">
          <Skeleton className="h-8 w-full rounded-md" />
        </div>
      </div>
    </Card>
  );
}; 